<div class="offers-filters filters-column"
     [ngClass]="{'offers-filters--embedded': embeddedInDialog, 'offers-filters--collapsed': !filtersService.filtersExpanded }">
  <div class="offers-filters__reset-filters-btn-wrapper" *ngIf="resetButtonVisible" [ngClass]="{'offers-filters__reset-filters-btn-wrapper--collapsed': !filtersService.anyFiltersSelected}">
    <button class="btn btn--tertiary-inverted offers-filters__reset-filters-btn"
            (click)="resetFilters()">
      {{ 'OFFER_SECTION.FILTERS_COMPONENT.clearFilters' | translate }}
    </button>
  </div>
  <div class="offers-filters__filters-container" [ngClass]="{'offers-filters__filters-container--filters-selected': filtersService.anyFiltersSelected}">
    <app-offers-filter
            *ngFor="let filter of offersFilters"
            [offersCountEnabled]="isNext"
            [filter]="filter">
    </app-offers-filter>
  </div>
</div>
